import { useState } from 'react';

export default function SuccessStories() {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  const testimonials = [
    { name: 'Taís Pinheiro', location: 'Sinop - MT', role: 'Modelo Internacional', video: 'fWZeK74x6Us', initial: 'T' },
    { name: 'Beatriz Zachert', location: 'Sorriso - MT', role: 'Modelo Internacional', video: 'GEI7zFUsukk', initial: 'B' },
    { name: 'Douglas Malmman', location: 'CEO da Mädchen Models', role: 'Modelo Internacional', video: 'Xvk5lA_x5ic', initial: 'D' },
    { name: 'Valentina Marques', location: 'Presidente Figueiredo - AM', role: 'Atriz', video: 'zLSADgvoVXI', initial: 'V' }
  ];

  const stats = [
    { value: '+50.000', label: 'Participantes em seletivas' },
    { value: '+1.000', label: 'Talentos descobertos' },
    { value: 'Brasil', label: 'Inteiro atendido' }
  ];

  const handlePlay = (videoId: string) => {
    setActiveVideo(videoId);
  };

  return (
    <section id="historias" className="py-14 sm:py-20 lg:py-28 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img 
          alt="Background" 
          className="w-full h-full object-cover object-top" 
          src="https://camponovodoparecis.fourmodelsseletivas.com.br/static/media/bg-testimonials.jpg"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <p className="text-xs font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Resultados reais
          </p>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-3">
            <a href="#historias">
              Histórias de <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Sucesso</span>
            </a>
          </h4>
          <p className="text-sm sm:text-base lg:text-lg text-gray-400 max-w-xl mx-auto">
            Assista os depoimentos de quem já passou pelas nossas seletivas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6 mb-8 sm:mb-10 lg:mb-12">
          {testimonials.map((item) => (
            <div key={item.video} className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 flex flex-col">
              <div className="relative w-full aspect-video bg-black">
                {activeVideo === item.video ? (
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${item.video}?autoplay=1&rel=0`}
                    title={`Depoimento de ${item.name}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <button
                    type="button"
                    onClick={() => handlePlay(item.video)}
                    className="absolute inset-0 w-full h-full cursor-pointer group"
                    aria-label={`Assistir depoimento de ${item.name}`}
                  >
                    <img 
                      alt={`Depoimento de ${item.name}`}
                      className="w-full h-full object-cover object-top" 
                      src={`https://img.youtube.com/vi/${item.video}/hqdefault.jpg`}
                    />
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-yellow-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-yellow-500/30">
                        <i className="ri-play-fill text-black text-2xl lg:text-3xl ml-1"></i>
                      </div>
                    </div>
                  </button>
                )}
              </div>

              <div className="p-4 sm:p-5 lg:p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-0.5 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-yellow-500"></i>
                  ))}
                </div>
                <div className="flex items-center gap-3 mt-auto">
                  <div className="w-9 h-9 lg:w-10 lg:h-10 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-black font-bold text-sm">{item.initial}</span>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm lg:text-base">{item.name}</p>
                    <p className="text-gray-500 text-xs">{item.location} • {item.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5 lg:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5 lg:p-8 text-center hover:bg-yellow-500/15 transition-all duration-300">
              <p className="text-2xl sm:text-3xl lg:text-5xl font-black text-yellow-500 mb-1 lg:mb-2">{stat.value}</p>
              <p className="text-gray-400 text-xs sm:text-sm lg:text-base">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
